import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=58c509d4&scoped=true&"
import script from "./QuestionModal.vue?vue&type=script&lang=js&"
export * from "./QuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionModal.vue?vue&type=style&index=0&id=58c509d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c509d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c509d4')) {
      api.createRecord('58c509d4', component.options)
    } else {
      api.reload('58c509d4', component.options)
    }
    module.hot.accept("./QuestionModal.vue?vue&type=template&id=58c509d4&scoped=true&", function () {
      api.rerender('58c509d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Portefeuille/QuestionModal.vue"
export default component.exports